import React from "react";
import { LiaEditSolid } from "react-icons/lia";
import { FaLinkedin, FaInstagram, FaGithub, FaBehance } from "react-icons/fa";
import { BsChatDots } from "react-icons/bs";

const SocialMedia = ({
  socialMediaInfo,
  onEditClick,
  showEdit = false,
  page,
}) => {
  return (
    <div
      className={`${
        page === "detay" ? "detay-container" : "profil4 flex flex-col gap-4"
      }`}
    >
      <div className="flex justify-between mt-4">
        <div className="flex items-center gap-3 text-dark text-lg tracking-wide font-medium">
          {page === "detay" && <BsChatDots className="size-[18px]" />}
          <span className="text-dark text-lg tracking-wide font-medium">
            Sosyal Medya
          </span>
        </div>
        {showEdit && (
          <span className="text-grayy" onClick={onEditClick}>
            <LiaEditSolid className="size-[24px]" />
          </span>
        )}
      </div>
      <ul className={`${page === "detay" ? "pt-4" : ""}`}>
        <li className="text-grayy flex items-center gap-4 mb-2">
          <FaLinkedin className="size-[20px]" />
          <span className="text-sm">{socialMediaInfo.linkedin}</span>
        </li>
        <li className="text-grayy flex items-center gap-4 my-2">
          <FaInstagram className="size-[20px]" />
          <span className="text-sm">{socialMediaInfo.instagram}</span>
        </li>
        <li className="text-grayy flex items-center gap-4 my-2">
          <FaGithub className="size-[20px]" />
          <span className="text-sm">{socialMediaInfo.github}</span>
        </li>
        <li className="text-grayy flex items-center gap-4 my-2">
          <FaBehance className="size-[20px]" />
          <span className="text-sm">{socialMediaInfo.behance}</span>
        </li>
      </ul>
    </div>
  );
};

export default React.memo(SocialMedia);
